import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['row', 'input', 'empty'];

  search() {
    const query = this.inputTarget.value.toLowerCase().trim();

    let visibleCount = 0;

    this.rowTargets.forEach((row) => {
      const text = row.dataset.searchText || '';
      const match = !query || text.includes(query);
      row.classList.toggle('d-none', !match);
      if (match) visibleCount += 1;
    });

    if (this.hasEmptyTarget) {
      this.emptyTarget.style.display = visibleCount === 0 ? '' : 'none';
    }
  }

  clear() {
    this.inputTarget.value = '';
    this.search();
  }
}
